var _mask, _path, _path2, _rect, _rect2, _rect3, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPedalRightDefault(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 138,
    viewBox: "0 0 60 138",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_3472_1348",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 2.92935C0 1.31152 1.31151 0 2.92935 0H57.0707C58.6885 0 60 1.31151 60 2.92935V135.071C60 136.688 58.6885 138 57.0707 138H2.92935C1.31151 138 0 136.688 0 135.071V2.92935Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2.92935C0 1.31152 1.31151 0 2.92935 0H57.0707C58.6885 0 60 1.31151 60 2.92935V135.071C60 136.688 58.6885 138 57.0707 138H2.92935C1.31151 138 0 136.688 0 135.071V2.92935Z",
    fill: "#D8D8D8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-2 -3.07065C-2 -5.79306 0.206944 -8 2.92935 -8H57.0707C59.7931 -8 62 -5.79306 62 -3.07065L58 8C58 8 57.5839 8 57.0707 8H2.92935C2.41608 8 2 8 2 8L-2 -3.07065ZM62 135.071C62 137.241 60.2408 139 58.0707 139H1.92935C-0.240771 139 -2 137.241 -2 135.071H2C2 136.136 2.41608 137 2.92935 137H57.0707C57.5839 137 58 136.136 58 135.071H62ZM1.92935 139C-0.240771 139 -2 137.241 -2 135.071V-3.07065C-2 -5.79306 0.206944 -8 2.92935 -8L2.92935 8C2.41608 8 2 8 2 8V135.071C2 136.136 2.41608 137 2.92935 137L1.92935 139ZM57.0707 -8C59.7931 -8 62 -5.79306 62 -3.07065V135.071C62 137.241 60.2408 139 58.0707 139L57.0707 137C57.5839 137 58 136.136 58 135.071V8C58 8 57.5839 8 57.0707 8V-8Z",
    fill: "#B7B7B7",
    mask: "url(#path-1-inside-1_3472_1348)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 12,
    width: 48,
    height: 14,
    fill: "#C6C6C6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 32,
    width: 48,
    height: 14,
    fill: "#C6C6C6"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 52,
    width: 48,
    height: 14,
    fill: "#C6C6C6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22 115V91H31.0056C32.7294 91 34.2006 91.3242 35.4192 91.9727C36.6452 92.6133 37.5777 93.5234 38.2167 94.7031C38.8632 95.875 39.1864 97.2539 39.1864 98.8398C39.1864 100.434 38.8594 101.805 38.2056 102.953C37.5517 104.094 36.6043 104.969 35.3635 105.578C34.13 106.188 32.6365 106.492 30.883 106.492H24.8533V102.414H30.1028C31.0241 102.414 31.7895 102.281 32.3988 102.016C33.008 101.75 33.4613 101.352 33.7585 100.82C34.0632 100.289 34.2155 99.6289 34.2155 98.8398C34.2155 98.043 34.0632 97.3711 33.7585 96.8242C33.4613 96.2773 33.0043 95.8633 32.3876 95.582C31.7783 95.293 31.0093 95.1484 30.0805 95.1484H26.826V115H22ZM34.3269 104.078L40 115H34.6724L29.122 104.078H34.3269Z",
    fill: "#9D9D9D"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPedalRightDefault);
export default __webpack_public_path__ + "static/media/pedal-right-default.39ff9f186b769e362dec3612ac8c1d8f.svg";
export { ForwardRef as ReactComponent };